import { apiFetch } from "../Services/apiFetch";

// Register new user
export const sendUserDataToBackend = async (userData) => {
  const result = await apiFetch("/manageUsers/register", {
    method: "POST",
    body: JSON.stringify(userData),
  });
  return result.data;
};

// Fetch users with pagination
export const fetchUsersFromBackend = async (page, limit) => {
  const result = await apiFetch(`/manageUsers/usersInfo?page=${page}&limit=${limit}`);
  const users = (result.data.users || []).map((u) => ({
    ...u,
    role: Object.values(u.roles || {}).includes("admin") ? "Admin" : "Operator",
  }));

  // Sort users with Admin always on top
  users.sort((a, b) => {
    if (a.role === "Admin" && b.role !== "Admin") return -1;
    if (a.role !== "Admin" && b.role === "Admin") return 1;
    return 0;
  });

  return users;
};

// Delete user
export const deleteUserFromBackend = async (id) => {
  if (!id) throw new Error("No user selected for deletion.");
  const result = await apiFetch(`/manageUsers/deleteUser/${id}`, { method: "DELETE" });
  return result.data;
};
